import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, FIREBASE_READY } from "../firebase";

const AppContext = createContext(null);

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
}

export function AppProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loaded,  setLoaded]  = useState(false);

  useEffect(() => {
    if (!FIREBASE_READY) { setLoaded(true); return; }
    const unsub = onAuthStateChanged(auth, user => { setIsAdmin(!!user); setLoaded(true); });
    return unsub;
  }, []);

  const handleLogout = async () => {
    if (FIREBASE_READY) await signOut(auth);
    setIsAdmin(false);
  };

  return (
    <AppContext.Provider value={{ isAdmin, setIsAdmin, handleLogout, loaded }}>
      {children}
    </AppContext.Provider>
  );
}
